import PersonalFilePathService from "../../services/personalFilePath.service";

const personalFilePathModule = {
	namespaced: true,
	state: {
		personalFilePath: null,
	},
	getters: {
		getPersonalFilePath(state) {
			return state.personalFilePath;
		}
	},
	actions: {
		async fetch({ commit }) {
			try {
				const personalFilePath = await PersonalFilePathService.fetch();
				commit('setPersonalFilePath', personalFilePath.data);
			} catch (e) {
				console.log(e);
			}
		}
	},
	mutations: {
		setPersonalFilePath(state, value) {
			state.personalFilePath = value;
		},
		reset(state) {
			Object.assign(state, {
				personalFilePath: null,
			});
		}
	},
};

export default personalFilePathModule;